import React from 'react'
import { Grid, Typography, Button, useTheme } from '@material-ui/core'
import emptyState from '../../assets/undraw_server_down_s-4-lk.svg'
import { useStore } from '../../context/Context'

const EmptyState = ({ text }) => {
  const { message } = useStore()
  const theme = useTheme()

  return (
    <Grid container justifyContent="center" alignItems="center" style={{ height: '100vh' }} direction="column">
      <Grid item style={{ marginBottom: '5em' }}>
        <Typography color="error" variant="h4">{text || message.msg}</Typography>
      </Grid>
      <Grid item>
        <img src={emptyState} alt="Empty State" width={500} />
      </Grid>
      <Grid item style={{ marginTop: '5em' }}>
        <Button onClick={() => window.location.href = message.link} variant="text" style={{ color: theme.palette.info.main }}>Try again</Button>
      </Grid>
    </Grid>
  )
}

export default EmptyState
